import i18next from 'i18next';
import { trackPromise } from 'react-promise-tracker';
import api from '../api/api';
import pdfApi from '../api/pdfApi';
import { CryptoUtil } from '../utils/CryptoUtil';

const encryptPersonalData = (personalData: object) => {
  const encryptedPersonalData = JSON.parse(JSON.stringify(personalData));
  encryptedPersonalData.apellido1 = btoa(
    CryptoUtil.encryptAes(encryptedPersonalData.apellido1),
  );
  encryptedPersonalData.apellido2 = btoa(
    CryptoUtil.encryptAes(encryptedPersonalData.apellido2),
  );
  encryptedPersonalData.emailContacto = btoa(
    CryptoUtil.encryptAes(encryptedPersonalData.emailContacto),
  );
  encryptedPersonalData.fechaNacimiento = btoa(
    CryptoUtil.encryptAes(encryptedPersonalData.fechaNacimiento),
  );
  encryptedPersonalData.genero = btoa(
    CryptoUtil.encryptAes(encryptedPersonalData.genero),
  );
  encryptedPersonalData.tipoDocumento = btoa(
    CryptoUtil.encryptAes(encryptedPersonalData.tipoDocumento),
  );
  encryptedPersonalData.idDocumento = btoa(
    CryptoUtil.encryptAes(encryptedPersonalData.idDocumento),
  );
  encryptedPersonalData.nombre = btoa(
    CryptoUtil.encryptAes(encryptedPersonalData.nombre),
  );
  encryptedPersonalData.prefijoTelefono = btoa(
    CryptoUtil.encryptAes(encryptedPersonalData.prefijoTelefono),
  );
  encryptedPersonalData.telefono = btoa(
    CryptoUtil.encryptAes(encryptedPersonalData.telefono),
  );
  encryptedPersonalData.prefijoTelefonoSecundario = btoa(
    CryptoUtil.encryptAes(encryptedPersonalData.prefijoTelefonoSecundario),
  );
  encryptedPersonalData.telefonoSecundario = btoa(
    CryptoUtil.encryptAes(encryptedPersonalData.telefonoSecundario),
  );
  encryptedPersonalData.tipoCambioMail = btoa(
    CryptoUtil.encryptAes(encryptedPersonalData.tipoCambioMail),
  );
  encryptedPersonalData.cif = btoa(
    CryptoUtil.encryptAes(encryptedPersonalData.cif),
  );
  encryptedPersonalData.razonSocial = btoa(
    CryptoUtil.encryptAes(encryptedPersonalData.razonSocial),
  );
  return encryptedPersonalData;
};

const encryptUpdateDireccionData = (data: object) => {
  const encryptedData = JSON.parse(JSON.stringify(data));
  encryptedData.directionName = btoa(
    CryptoUtil.encryptAes(encryptedData.directionName),
  );
  encryptedData.email = btoa(CryptoUtil.encryptAes(encryptedData.email));
  encryptedData.locality = btoa(CryptoUtil.encryptAes(encryptedData.locality));
  encryptedData.number = btoa(CryptoUtil.encryptAes(encryptedData.number));
  encryptedData.portal = btoa(CryptoUtil.encryptAes(encryptedData.portal));
  encryptedData.stairs = btoa(CryptoUtil.encryptAes(encryptedData.stairs));
  encryptedData.door = btoa(CryptoUtil.encryptAes(encryptedData.door));
  encryptedData.floor = btoa(CryptoUtil.encryptAes(encryptedData.floor));
  encryptedData.postalCode = btoa(
    CryptoUtil.encryptAes(encryptedData.postalCode),
  );
  encryptedData.reception = btoa(
    CryptoUtil.encryptAes(encryptedData.reception),
  );
  encryptedData.roadType = btoa(CryptoUtil.encryptAes(encryptedData.roadType));
  encryptedData.roadName = btoa(CryptoUtil.encryptAes(encryptedData.roadName));
  encryptedData.idPrefTelefono1 = btoa(
    CryptoUtil.encryptAes(encryptedData.idPrefTelefono1),
  );
  encryptedData.telefono1 = btoa(
    CryptoUtil.encryptAes(encryptedData.telefono1),
  );
  encryptedData.glPlaceId = btoa(
    CryptoUtil.encryptAes(encryptedData.glPlaceId),
  );
  encryptedData.glPlaceLatitud = btoa(
    CryptoUtil.encryptAes(encryptedData.glPlaceLatitud),
  );
  encryptedData.glPlaceLongitud = btoa(
    CryptoUtil.encryptAes(encryptedData.glPlaceLongitud),
  );
  encryptedData.glPlaceType = btoa(
    CryptoUtil.encryptAes(encryptedData.glPlaceType),
  );

  return encryptedData;
};

const encryptSendSmsDobleVerif = (data: object) => {
  const encryptedData = JSON.parse(JSON.stringify(data));
  encryptedData.prefijo = btoa(CryptoUtil.encryptAes(encryptedData.prefijo));
  encryptedData.telefono = btoa(CryptoUtil.encryptAes(encryptedData.telefono));
  return encryptedData;
};

const DataService = {
  personalData: () =>
    trackPromise(api.post('/rest/misdatos/get/datos/personales')),

  updatePersonalData: (data: object, tipoUsuario: string) =>
    trackPromise(
      api.put(
        `/rest/misdatos/${i18next.language}/update/datos/personales/${tipoUsuario}`,
        JSON.stringify(encryptPersonalData(data)),
      ),
    ),

  familiarData: () =>
    trackPromise(api.post('/rest/misdatos/get/datos/familia/numerosa')),

  updateFamiliarData: (data: object) =>
    trackPromise(
      api.put(
        '/rest/misdatos/update/datos/familia/numerosa',
        JSON.stringify(data),
      ),
    ),

  accessData: (data: object) =>
    trackPromise(
      api.post('/rest/misdatos/get/datos/acceso', JSON.stringify(data)),
    ),

  subscripciones: () =>
    trackPromise(api.post('rest/misdatos/get/datos/suscripciones')),

  rrss: () => trackPromise(api.post('rest/misdatos/get/datos/rrss')),

  vincularRrss: (data: object) =>
    trackPromise(
      api.put('/rest/misdatos/update/vincular/rss', JSON.stringify(data)),
    ),

  desvincularRrss: (data: object) =>
    trackPromise(
      api.put('/rest/misdatos/update/desvincular/rss', JSON.stringify(data)),
    ),

  updateSubscripciones: (data: object) =>
    api.put('/rest/misdatos/update/datos/suscripciones', JSON.stringify(data)),

  valesAhorro: () =>
    trackPromise(api.post('rest/misdatos/get/datos/vales/ahorro')),

  updateValesAhorro: (data: object) =>
    trackPromise(
      api.put('/rest/misdatos/update/datos/vales/ahorro', JSON.stringify(data)),
    ),

  direcciones: () =>
    trackPromise(api.post('/rest/misdatos/get/datos/direcciones')),

  serviciosSuscritos: () =>
    trackPromise(api.post('/rest/misdatos/get/servicios/suscritos')),

  prefijoPais: () =>
    trackPromise(api.post('/rest/app/config/get/available/prefijos')),

  prefijoPaisMixtos: () =>
    trackPromise(api.post('/rest/app/config/get/prefijos/mixtos')),

  getTiposDocumento: () =>
    trackPromise(api.post('/rest/app/config/get/tipos/documento')),

  getTiposDocumentoKosmos: () =>
    trackPromise(api.post('/rest/app/config/get/tipos/documento/kosmos')),

  getTiposViaParaDirecciones: () =>
    trackPromise(api.post('/rest/misdatos/get/datos/direcciones/tipoVia')),

  getPaisesParaDirecciones: () =>
    trackPromise(api.post('/rest/misdatos/get/datos/direcciones/paises')),

  getTesauro: () => trackPromise(api.post('/rest/app/config/get/tesauro')),

  getProvinciaByCodigoPostal: (data: object) =>
    trackPromise(
      api.post(
        '/rest/misdatos/get/datos/direccion/facturacion',
        JSON.stringify(data),
      ),
    ),

  getRazonSocialByCif: (data: object) =>
    trackPromise(
      api.post('/rest/misdatos/get/razonsocial', JSON.stringify(data)),
    ),

  updateDireccion: (data: object) =>
    trackPromise(
      api.put(
        `/rest/misdatos/${i18next.language}/update/direccion`,
        JSON.stringify(encryptUpdateDireccionData(data)),
      ),
    ),

  deleteDireccion: (data: object) =>
    trackPromise(
      api.put('/rest/misdatos/delete/direccion', JSON.stringify(data)),
    ),

  getPassSugerida: () =>
    trackPromise(api.post('/rest/misdatos/get/pass/sugerida')),

  updateEmailAcceso: (data: object) =>
    trackPromise(
      api.put(
        `/rest/misdatos/${i18next.language}/update/datos/acceso/email`,
        JSON.stringify(data),
      ),
    ),

  updatePassAcceso: (data: object) =>
    trackPromise(
      api.put(
        '/rest/misdatos/update/datos/acceso/password',
        JSON.stringify(data),
      ),
    ),

  checkPrevalidacionDatos: () =>
    trackPromise(api.post('/rest/misdatos/check/prevalidacion/datos')),

  getTelfDatosAcceso: () =>
    trackPromise(
      api.post('/rest/misdatos/get/phone/datos/acceso/dobleverificacion'),
    ),

  sendSmsDobleVerif: (data: object) =>
    trackPromise(
      api.put(
        '/rest/misdatos/send/sms/datos/acceso/dobleverificacion',
        JSON.stringify(encryptSendSmsDobleVerif(data)),
      ),
    ),

  updateDatosAcceso: (data: object) =>
    trackPromise(
      api.put(
        '/rest/misdatos/update/datos/acceso/dobleverificacion',
        JSON.stringify(data),
      ),
    ),

  bajaDigital: (data: object) =>
    trackPromise(api.put('/rest/misdatos/baja/digital', JSON.stringify(data))),

  bajaEroskiClub: (data: object) =>
    trackPromise(api.put('/rest/misdatos/baja/socio', JSON.stringify(data))),

  googlePlaceAutoComplete: (data: object) =>
    api.post(
      `/rest/${i18next.language}/google/place/autocomplete`,
      JSON.stringify(data),
    ),

  googlePlaceAutoCompleteAddress: (data: object) =>
    api.post(
      `/rest/${i18next.language}/google/place/autocomplete/address`,
      JSON.stringify(data),
    ),

  googlePlaceDetails: (data: object) =>
    api.post(
      `/rest/${i18next.language}/google/place/details`,
      JSON.stringify(data),
    ),

  logoutMultidispositivo: (data: object) =>
    trackPromise(
      api.put('/rest/misdatos/logout/multidispositivos', JSON.stringify(data)),
    ),

  logoutUserForBaja: (data: string) =>
    trackPromise(api.put(`/rest/user/config/deslogar/usuario?fromApp=${data}`)),

  bajaFormDownload: () =>
    trackPromise(
      pdfApi.get(
        `/rest/misdatos/${i18next.language}/download/pdf/baja/socioconsumidor`,
      ),
    ),

  getSmsCode: () =>
    trackPromise(api.post('/rest/misdatos/codigo/verificacion/get')),

  getCorporativeMail: (data: object) =>
    trackPromise(
      api.post(
        '/rest/misdatos/validar/getCorporativeMail',
        JSON.stringify(data),
      ),
    ),
};
export default DataService;
